module.exports = __webpack_public_path__ + "fontawesome-webfont.f775f9cca88e21d45beb.svg";


//////////////////
// WEBPACK FOOTER
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/assets/fonts/fontawesome-webfont.svg?v=4.1.0
// module id = ../../../../../src/assets/fonts/fontawesome-webfont.svg?v=4.1.0
// module chunks = styles